import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { isDevelopment, isStage } from "../../utils/helpers/environment";
import deTranslations from "../locales/de.json";
import enTranslations from "../locales/en.json";
import esTranslations from "../locales/es.json";
import frTranslations from "../locales/fr.json";
import itTranslations from "../locales/it.json";
import ptTranslations from "../locales/pt.json";
import zhTranslations from "../locales/zh.json";

i18n.use(LanguageDetector).use(initReactI18next);

export function initI18n() {
  return i18n.init({
    debug: isDevelopment() || isStage(),
    fallbackLng: "en",
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslations,
      },
      de: {
        translation: deTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      es: {
        translation: esTranslations,
      },
      it: {
        translation: itTranslations,
      },
      pt: {
        translation: ptTranslations,
      },
      zh: {
        translation: zhTranslations,
      },
    },
  });
}

export default i18n;
